var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CollapseCircleIcon, ExpandCircleIcon } from '@marketing-icons';
import { clsx } from 'clsx';
import { useLocation } from 'react-router';
function Accordion(_a) {
    var _b = _a.buttonTheme, buttonTheme = _b === void 0 ? 'dark' : _b, children = _a.children, contentStyles = _a.contentStyles, detailsClassName = _a.detailsClassName, summaryClassName = _a.summaryClassName, title = _a.title, titleClassName = _a.titleClassName;
    var pathname = useLocation().pathname;
    var expandTheme = buttonTheme === 'gray-filled-collapse' ? 'gray' : buttonTheme;
    var collapseTheme = buttonTheme === 'gray-filled-collapse' ? 'gray-filled' : buttonTheme;
    var expandIconClassName = clsx(expandTheme === 'gray'
        ? 'border-icon-light-grey text-icon-dark'
        : expandTheme === 'dark'
            ? 'border-icon-white text-icon-white'
            : 'border-icon-dark text-icon-dark', 'group-open:hidden shrink-0');
    var collapseIconClassName = clsx(collapseTheme === 'gray-filled'
        ? 'border-icon-light-grey text-icon-dark fill-icon-light-grey'
        : collapseTheme === 'dark'
            ? 'border-icon-white text-icon-white'
            : 'border-icon-dark text-icon-dark', 'hidden group-open:inline shrink-0');
    return (_jsxs("details", __assign({ className: clsx('group flex flex-col justify-between items-start rounded-[12px]', detailsClassName) }, { children: [_jsxs("summary", __assign({ className: clsx('flex w-full justify-between items-center gap-xl-m', summaryClassName) }, { children: [_jsx("span", __assign({ className: clsx('text-lg-med-m md:text-lg-med-d', titleClassName) }, { children: title })), _jsx(CollapseCircleIcon, { className: collapseIconClassName }), _jsx(ExpandCircleIcon, { className: expandIconClassName })] })), _jsx("div", __assign({ className: clsx('w-full overflow-hidden', contentStyles) }, { children: children }))] }), "".concat(pathname, "-").concat(title)));
}
export default Accordion;
